import snakeCase from "lodash.snakecase";
export const createLogEntryKeyParam = key => `p_${snakeCase(key)}`;
export const mapToSnakeCase = object => {
  object = object || {};
  return Object.keys(object).reduce((acc, key) => {
    acc[snakeCase(key)] = object[key];
    return acc;
  }, {});
};
export const getTrackAction = payload => {
  const params = {};
  let actionId = payload;

  if (typeof payload === "object") {
    for (const key in payload) {
      if (key !== "actionId") {
        params[createLogEntryKeyParam(key)] = payload[key];
      }
    }

    actionId = payload.actionId;
  }

  return [actionId, params];
};
export const createLogEntryPayload = (actionId, params) => ({ ...params,
  actionId
});
export const getLogEntryActionPayload = (action, args) => {
  if (typeof action === "function") {
    action = action(...args);
  }

  return action;
};
/*
  This helper method to convert analytics.js component obj to trackable component props
  const COMPONENT = {LOAD: 'zxxxxx', INTERFACE_ID: 'yyyyyyyyy'};
  withTrack(trackProps(COMPONENT)) or <Trackable {...trackProps(COMPONENT)}>
 */

export const trackProps = (meta = {}) => ({
  interfaceId: meta.INTERFACE_ID,
  loadId: meta.LOAD
});